import { Observable, of } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanActivateChild,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';

import { PageService } from '~shared/services/page.service';
import { AuthorizationIdamStateService } from '~app/modules/authorization/services/authorization-idam-state.service';
import { AuthorizationStateType } from '~app/modules/authorization/constants/authorization.constant';
import { AuthService } from '~app/modules/authorization/services/authorization-idam.service';
import { isPlatformServer } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate, CanActivateChild {
  constructor(
    private readonly pageService: PageService,
    private readonly authorizationIdamStateService: AuthorizationIdamStateService,
    private readonly authService: AuthService,
    @Inject(PLATFORM_ID) private platform: Object,
  ) {}

  public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    if (isPlatformServer(this.platform)) {
      return of(true);
    }

    return this.authorizationIdamStateService.state$.pipe(
      filter(({ type }) => type !== AuthorizationStateType.Pending),
      map(({ type }) => {
        if (type === AuthorizationStateType.LoggedIn) {
          return true;
        } else {
          this.authService.login(state.url.split('?')[0]);
          return false;
        }
      })
    );
  }

  public canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> {
    return this.canActivate(childRoute, state);
  }
}
